// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/work-optimization/DependencyInsightCard.jsx

import React from "react";

export default function DependencyInsightCard({ insight }) {
  const safeInsight = insight && typeof insight === "object" ? insight : null;
  if (!safeInsight) return null;

  const reasons = Array.isArray(safeInsight.why) ? safeInsight.why : [];

  return (
    <section className="wo-card wo-dependency-card" aria-label="Dependency insight">
      <div className="wo-card-header">
        <div>
          <span>Dependency Insight</span>
          <h3>{safeInsight.label || safeInsight.title || "Dependency-aware sequencing"}</h3>
          <p>{safeInsight.reason || safeInsight.operator_note || "Review the dependency before changing task state."}</p>
        </div>
      </div>
      {reasons.length ? (
        <ul className="wo-reasons">
          {reasons.slice(0, 4).map((reason, index) => <li key={`dependency-reason-${index}`}>{reason}</li>)}
        </ul>
      ) : null}
    </section>
  );
}
